<template>
  <div
    data-tour="reports-header"
    class="overflow-auto bg-n-surface-1 w-full px-6"
  >
    <div class="max-w-5xl mx-auto pb-12">
      <router-view />
    </div>
  </div>
</template>
